import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const GridCustomHeader = forwardRef((props, ref) => {
    const { displayName, column } = props;
    const [sortState, setSortState] = useState('');

    const onSortRequested = event => {
        // Cycle through sort states: none -> asc -> desc -> none
        let nextSort;
        if (!sortState) {
            nextSort = 'asc';
        } else if (sortState === 'asc') {
            nextSort = 'desc';
        } else {
            nextSort = null;
        }
        props.setSort(nextSort, event.shiftKey);
    };

    useEffect(() => {
        const sortChangedListener = () => {
            const currentSort = props.column.getSort();
            setSortState(currentSort || '');
        };

        props.column.addEventListener('sortChanged', sortChangedListener);

        // Initial sort state
        sortChangedListener();

        return () => {
            props.column.removeEventListener('sortChanged', sortChangedListener);
        };
    }, [props.column]);

    useImperativeHandle(ref, () => ({
        refresh: () => true,
    }));

    const headerText = column.colDef.context?.originalDisplayName || displayName;

    return (
        <div className="ag-header-cell-label">
            <div className="ag-header-cell-text" onClick={onSortRequested}>
                {headerText}
            </div>
            {sortState && (
                <span className={`ag-sort-indicator-icon ag-sort-${sortState}-icon`}>
                    {sortState === 'asc' ? '↑' : '↓'}
                </span>
            )}
        </div>
    );
});

GridCustomHeader.displayName = 'GridCustomHeader';

GridCustomHeader.propTypes = {
    displayName: PropTypes.string.isRequired,
    column: PropTypes.object.isRequired,
    setSort: PropTypes.func.isRequired,
};

export default GridCustomHeader;
